<template>
  <v-row justify="center">
    <v-dialog :value="dialogBank" persistent>
      <v-card>
        <v-card-title class="headline">
          Информация по банку
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="CloseBankWindow">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <template v-if="editedItemBank != null">
            <v-simple-table fixed-header height="600px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Название параметра</th>
                    <th>Значение параметра</th>
                    <th>Пояснение</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="30%">
                      Название
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span max-width="300"
                          >Указано наименование банка, ИНН банка, а также его
                          регистрационный номер (номер лицензии).</span
                        >
                      </v-tooltip>
                    </td>
                    <td width="30%">{{ editedItemBank.name }}</td>
                    <td width="40%">{{ editedItemBank.name_note }}</td>
                  </tr>
                  <tr>
                    <td>Полное название</td>
                    <td>{{ editedItemBank.fullname }}</td>
                    <td>{{ editedItemBank.fullname_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Партнерские отношения
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указано, является ли банк партнером сервиса по выдаче
                          банковских гарантий</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemBank.partnership | toBool }}</td>
                    <td>{{ editedItemBank.partnership_note }}</td>
                  </tr>
                  <tr>
                    <td>ИНН банка</td>
                    <td>{{ editedItemBank.inn }}</td>
                    <td>{{ editedItemBank.inn_note }}</td>
                  </tr>
                  <tr>
                    <td>Лицензия</td>
                    <td>{{ editedItemBank.license }}</td>
                    <td>{{ editedItemBank.license_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Рассмотрение нестандартных заявок
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>
                          "Указано, рассматривает ли банк заявки на гарантии вне
                          рамок стандартных программ: Рассматривает - можно
                          направлять заявки вне стандартных программ, также
                          может быть указана дополнительная информация
                          (минимальная и максимальная сумма по гарантии, срок
                          гарантии, возможность получения вознаграждения за
                          выдачу нестандарта) Не рассматривает - заявки
                          принимаются только в рамках действующих программ"
                        </span>
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemBank.outside_request | toBool }}</td>
                    <td>{{ editedItemBank.outside_request_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Выдает кредит на исполнение контракта/договора
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указано, может ли банк выдать кредит на исполнение
                          контракта (договора). Если выдает, может быть указана
                          дополнительная информация об условиях получения
                          кредита.</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemBank.credit_contract | toBool }}</td>
                    <td>{{ editedItemBank.credit_contract_yes_more }}</td>
                  </tr>
                  <tr>
                    <td>Перечни</td>
                    <td>{{ editedItemBank.list }}</td>
                    <td>{{ editedItemBank.list_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Сайт банка:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указан один или несколько официальных сайтов банка,
                          по информации Центробанка</span
                        >
                      </v-tooltip>
                    </td>
                    <td>
                      {{ openedWebsite }}
                    </td>
                    <td>{{ editedItemBank.website_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Рейтинг банка «АКРА»
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>
                          "Указан рейтинг банка от аккредитованного Центробанком
                          кредитного рейтингово агентства АО ""АКРА"". Наивысший
                          рейтинг - AAA(RU), наименьший - D(RU) О расшифровке
                          значений рейтинга можно узнать здесь:
                          https://www.acra-ratings.ru/about-ratings/scales
                          Согласно Постановления Правительства от 12 апреля 2018
                          г. № 440 ""О требованиях к банкам, которые вправе
                          выдавать банковские гарантии для обеспечения заявок и
                          исполнения контрактов"", для выдачи гараний с
                          01.06.2018 г. у банка должен быть рейтинг не ниже
                          B-(RU)."
                        </span>
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemBank.acra }}</td>
                    <td>{{ editedItemBank.acra_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Рейтинг банка от «Эксперт РА»:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>
                          "Указан рейтинг банка от аккредитованного Центробанком
                          кредитного рейтингово агентства АО ""Эксперт РА"".
                          Наивысший рейтинг - ruAAA+, наименьший - ruD Подробне
                          о значениях рейтинга можно узнать здесь:
                          https://raexpert.ru/releases/2017/Mar30l/ Согласно
                          Постановления Правительства от 12 апреля 2018 г. № 440
                          ""О требованиях к банкам, которые вправе выдавать
                          банковские гарантии для обеспечения заявок и
                          исполнения контрактов"", для выдачи гараний с
                          01.06.2018 г. у банка должен быть рейтинг не ниже
                          ruB-."
                        </span>
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemBank.raexpert }}</td>
                    <td>{{ editedItemBank.raexpert_note }}</td>
                  </tr>

                  <tr>
                    <td>
                      Рейтинг банка от «НКР»:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>
                          "Указан рейтинг банка от аккредитованного Центробанком
                          кредитного рейтингового агентства ООО "НКР". Наивысший
                          рейтинг - AAA.ru, наименьший - D. О расшифровке
                          значений рейтинга можно узнать здесь:
                          https://ratings.ru/methodologies/scales/ Согласно
                          Постановления Правительства от 20 декабря 2021г. № 440
                          "О требованиях к банкам, которые вправе выдавать
                          банковские гарантии для обеспечения заявок и
                          исполнения контрактов", для выдачи гарантий 1 января
                          2022 г. у банка должен быть рейтинг не ниже "В-.ru"
                        </span>
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemBank.nkp }}</td>
                    <td>{{ editedItemBank.nkp_note }}</td>
                  </tr>

                  <tr>
                    <td>
                      Рейтинг банка от «НРА»:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>
                          "Указан рейтинг банка от аккредитованного Центробанком
                          кредитного рейтингового агентства ООО "НРА". Наивысший
                          рейтинг - AAA|ru|, наименьший - D|ru|. О расшифровке
                          значений рейтинга можно узнать здесь:
                          https://www.ra-national.ru/reitingovye-shkaly/nacionalnaja-rejtingovaja-shkala-dlja-r/
                          Согласно Постановления Правительства от 20 декабря
                          2021г. № 440 "О требованиях к банкам, которые вправе
                          выдавать банковские гарантии для обеспечения заявок и
                          исполнения контрактов", для выдачи гарантий 1 января
                          2022 г. у банка должен быть рейтинг не ниже "В-|ru|"
                        </span>
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemBank.npa }}</td>
                    <td>{{ editedItemBank.npa_note }}</td>
                  </tr>

                  <tr>
                    <td>
                      Капитал, тыс. руб.:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указаны размер капитала банка (Базель III, ф. 123) и
                          размер активов банка по информации, предоставленной
                          Центробанку</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemBank.capital }}</td>
                    <td>{{ editedItemBank.capital_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Активы, тыс. руб.:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указаны размер капитала банка (Базель III, ф. 123) и
                          размер активов банка по информации, предоставленной
                          Центробанку</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemBank.assets }}</td>
                    <td>{{ editedItemBank.assets_note }}</td>
                  </tr>
                  <tr>
                    <td>Логотип:</td>
                    <td><img :src="editedItemBank.logo" alt="лого банка" /></td>
                    <td></td>
                    <!-- <td>
                      <v-img
                        v-if="editedItemBank.logo"
                        max-height="100"
                        max-width="100"
                        :src="getImage(editedItemBank.logo)"
                      ></v-img>
                    </td> -->
                  </tr>

                  <!-- <tr>
                    <td>Активировано:</td>
                    <td>{{ editedItemBank.active | toBool }}</td>
                    <td></td>
                  </tr> -->
                </tbody>
              </template>
            </v-simple-table>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["editedItemBank"],
  data() {
    return {
      openedWebsite: "",
    };
  },
  methods: {
    CloseBankWindow() {
      this.$store
        .dispatch("toggleBankViewWindow", false)
        .then(() => {})
        .catch((error) => {
          alert(error);
        });
    },
    getImage(url) {
      const imgurl = "http://localhost:8081/storage/uploads/" + url;
      return imgurl;
      //return this.$http.options.root +"/storage/uploads/" + url;
    },
    async getWebsites(idArr) {
      const { data } = await this.$store.dispatch(
        "getWebsite",
        JSON.parse(idArr)[0]
      );
      if (data) {
        this.openedWebsite = data.name;
      }
    },
  },
  computed: {
    dialogBank() {
      return this.$store.getters.getDialogBankView;
    },
  },
  filters: {
    toIndividual: function (value) {
      if (value == 0 || value == "0") return "индивидуально";
      return value;
    },
    toBool(val) {
      if (val) return "ДА";
      else return "Нет";
    },
  },
  mounted() {
    this.setTitle(`Информация по банку`);
  },
  watch: {
    editedItemBank(val) {
      this.getWebsites(val.website);
    },
  },
};
</script>

<style lang="scss">
#app {
  .theme--light.v-input:not(.v-input--is-disabled) input,
  .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: #217899;
  }
  h1 {
    font-size: 1.5rem;
  }
  .bluelink {
    color: #217899;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  .v-data-table-header tr th {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .v-data-table-header tr th {
    font-size: 14px;
  }
  .v-dialog table thead tr th {
    font-size: 14px;
  }
}
</style>
